export const AVATAR_COLORS = [
    '232, 105, 156',
    '255, 198, 115',
    '128, 128, 255',
    '105, 232, 194',
    '234, 255, 128',
];
export const AVATAR_OPACITY = 0.4;

export const getWidgetCode = widget => {
    const widgetscode = {
        'button-bar': 26999,
        CTA: 66199,
        webpage: 68099,
        timer: 36999,
        'media-share': 52199,
        'hide-popup': 48399,
        'presenter-note': 83799,
    };
    return widgetscode[widget];
};

export const TILE_ASPECT_RATIO = 16 / 9;
export const viewType = {
    active: 'active',
    gallery: 'gallery',
    presentation: 'presentation',
    audience: 'audience',
};
export const TRANSCRIBER_DIAL_NUMBER = 'jitsi_meet_transcribe';
export const P_NAME_REQUESTING_TRANSCRIPTION = 'requestingTranscription';
export const P_NAME_TRANSLATION_LANGUAGE = 'translation_language';
export const P_NAME_TRANSCRIPTION_LANGUAGE = 'transcription_language';

export const COUNTRY_CODES = {
  en: ['en', 'en-US'],
  af: ['af', 'af-ZA'],
  ar: ['ar', 'ar-SA'],
  bg: ['bg', 'bg-BG'],
  ca: ['ca', 'ca-ES'],
  cs: ['cs', 'cs-CZ'],
  da: ['da', 'da-DK'],
  de: ['de', 'de-DE'],
  el: ['el', 'el-GR'],
  et: ['et', 'et-EE'],
  enGB: ['en', 'en-GB'],
  es: ['es', 'es-ES'],
  esUS: ['es', 'es-US'],
  eu: ['eu', 'eu-ES'],
  fi: ['fi', 'fi-FI'],
  fr: ['fr', 'fr-FR'],
  frCA: ['fr', 'fr-CA'],
  he: ['he', 'he-IL'],
  hi: ['hi', 'hi-IN'],
  hr: ['hr', 'hr-HR'],
  hu: ['hu', 'hu-HU'],
  id: ['id', 'id-ID'],
  it: ['it', 'it-IT'],
  ja: ['ja', 'ja-JP'],
  ko: ['ko', 'ko-KR'],
  lt: ['lt', 'lt-LT'],
  ms: ['ms', 'ms-MY'],
  nl: ['nl', 'nl-NL'],
  fa: ['fa', 'fa-IR'],
  pl: ['pl', 'pl-PL'],
  pt: ['pt', 'pt-PT'],
  ptBR: ['pt', 'pt-BR'],
  ru: ['ru', 'ru-RU'],
  ro: ['ro', 'ro-RO'],
  sk: ['sk', 'sk-SK'],
  sl: ['sl', 'sl-SI'],
  sr: ['sr', 'sr-RS'],
  sv: ['sv', 'sv-SE'],
  sw: ['sw', 'sw-KE'],
  tl: ['tl ', 'tl-PH'],
  fil: ['fil', 'fil-PH'],
  ta: ['ta', 'ta-IN'],
  te: ['te', 'te-IN'],
  th: ['th', 'th-TH'],
  tr: ['tr', 'tr-TR'],
  uk: ['uk', 'uk-UA'],
  vi: ['vi', 'vi-VN'],
  zhCN: ['zh', 'zh-CN'],
  zhTW: ['zh-TW', 'zh-TW'],
};